<!-- Loading State -->
@if (!galleryProductsLoaded) {
  <div class="d-flex justify-content-center align-items-center flex-column"
    style="min-height: 200px;">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
    <p class="text-muted mt-2">{{ 'syncProducts.loadingProducts' | transloco }}</p>
  </div>
}

<!-- Product List Section -->
@if (galleryProductsLoaded) {
  <div class="row my-2">
    <!-- Header Section with Filter -->
    <div class="d-flex justify-content-between">
      <div>
        <p class="text-muted fs-5 mt-2">
          {{ 'syncProducts.synchronisedWithStore' | transloco }}
        </p>
      </div>
      <div>
        @if (showStoreFilter) {
          <div>
            <p-dropdown
              [options]="storeFilterOptions"
              [(ngModel)]="selectedStoreFilter"
              [placeholder]="'syncProducts.filterByStore' | transloco"
              optionLabel="label"
              optionValue="value"
              [showClear]="true"
              (onChange)="onStoreFilterChange()"
              (onClear)="onStoreFilterChange()">
              <ng-template pTemplate="empty">
                <div class="text-muted p-2">{{ 'syncProducts.noStoresAvailable' | transloco }}</div>
              </ng-template>
            </p-dropdown>
          </div>
        }
      </div>
    </div>
    <!-- Empty State -->
    @if (SyncProducts?.length === 0) {
      <div class="text-center text-warning">
        <p>{{ 'syncProducts.noProductsMatchingFilter' | transloco }}</p>
      </div>
    }
    <!-- Product Grid -->
    @if (SyncProducts && SyncProducts.length > 0) {
      <div class="row g-3">
        @for (product of SyncProducts; track product) {
          <div class="col-4 mt-2 gallery-tile">
            <div (click)="showProductDetails(product)">
              <div class="custom-product-container border cursor-pointer position-relative">
                <!-- Status Badges -->
                @if (product) {
                  @if (product.IsConsignedProduct && !product.IsProductSold) {
                    <span class="badge bg-danger position-absolute start-0 top-0 my-1 ms-1"
                      >
                      {{ 'syncProducts.consigned' | transloco }}
                    </span>
                  }
                  @if (product.IsProductSold && !product.IsConsignedProduct) {
                    <span class="badge bg-danger sold position-absolute start-0 top-0 my-1 mx-1 ng-star-inserted"
                      >
                      {{ 'syncProducts.sold' | transloco }}
                    </span>
                  }
                  @if (!product.IsConsignedProduct && !product.IsProductSold) {
                    <span class="badge bg-success position-absolute start-0 top-0 my-1 ms-1"
                      >
                      {{ 'syncProducts.available' | transloco }}
                    </span>
                  }
                }
                <!-- Product Image -->
                <div class="custom-img-container">
                  <img [src]="product.Product.ProductImgUrl ? product.Product.ProductImgUrl : 'assets/images/No-Image.png'"
                    class="custom-img rounded-cube border" [alt]="'syncProducts.productImage' | transloco" style="height: 105px;">
                  </div>
                  <!-- Product Details -->
                  @if (product.Product) {
                    <div class="d-flex flex-column p-1 mb-2 w-100">
                      <div class="d-flex flex-row justify-content-between position-relative">
                        <!-- Product Name -->
                        <div class="text-uppercase fw-semibold ellipsis">
                          <a href="javascript:void(0);" class="text-uppercase text-dark fw-semibold"
                            pTooltip="{{ product.Product.Name }}">
                            {{ product.Product.Name }}
                          </a>
                        </div>
                        <!-- Action Menu (Only for Available Products) -->
                        @if (!product.IsConsignedProduct && !product.IsProductSold) {
                          <div class="position-absolute end-0 top-0 d-flex align-items-center p-1"
                            >
                            <button class="btn btn-link text-dark p-0"
                              (click)="openRemoveProductDialog(product); $event.stopPropagation()">
                              <i class="pi pi-ellipsis-v"></i>
                            </button>
                          </div>
                        }
                      </div>
                      <!-- Detailed Product Info -->
                      <div class="small">
                        <!-- Artist Name -->
                        @if (product.ArtistName) {
                          <div class="d-flex flex-row justify-content-between">
                            <div class="d-flex align-items-center cursor-pointer">
                              <div class="fw-semibold text-uppercase">{{ 'syncProducts.artistLabel' | transloco }} </div>
                              <div class="ms-1">{{ product.ArtistName }}</div>
                            </div>
                          </div>
                        }
                        <!-- Unified Product Details Section -->
                        <div class="d-flex flex-column">
                          <!-- Date Section -->
                          <div class="d-flex align-items-center">
                            <div class="fw-semibold text-uppercase">
                              @if (authConfig?.IsArtist) {
                                {{ 'syncProducts.createdDate' | transloco }}
                              }
                              @if (authConfig?.IsGallery) {
                                @if (!product.IsProductSold) {
                                  {{ 'syncProducts.dateAccepted' | transloco }}
                                }
                                @if (product.IsProductSold) {
                                  {{ 'syncProducts.dateSold' | transloco }}
                                }
                              }
                            </div>
                            <div class="ms-1 text-capitalize">
                              @if (authConfig?.IsArtist) {
                                {{ product.Product.CreatedDate | date: 'dd/MM/yyyy' }}
                              }
                              @if (authConfig?.IsGallery) {
                                @if (!product.IsProductSold) {
                                  {{ product.GalleryAcceptedDate | date: 'dd/MM/yyyy' }}
                                  @if (product.AcceptedBeforeXDays === 0) {
                                    {{ 'syncProducts.today' | transloco }}
                                  }
                                  @if (product.AcceptedBeforeXDays) {
                                    {{ 'syncProducts.daysCount' | transloco: { count: product.AcceptedBeforeXDays } }}
                                  }
                                }
                                @if (product.IsProductSold) {
                                  {{ product.ProductSoldDate | date: 'dd/MM/yyyy' }}
                                  @if (product.SoldBeforeXDays === 0) {
                                    {{ 'syncProducts.today' | transloco }}
                                  }
                                  @if (product.SoldBeforeXDays) {
                                    {{ 'syncProducts.daysCount' | transloco: { count: product.SoldBeforeXDays } }}
                                  }
                                }
                              }
                            </div>
                          </div>
                          <!-- Price / Revenue Section -->
                          <div class="d-flex align-items-center">
                            <div class="fw-semibold text-uppercase">
                              @if (authConfig?.IsArtist) {
                                {{ 'syncProducts.artistRevenue' | transloco }}
                              }
                              @if (authConfig?.IsGallery) {
                                @if (!product.IsProductSold) {
                                  {{ 'syncProducts.retailPrice' | transloco }}
                                }
                                @if (product.IsProductSold) {
                                  {{ 'syncProducts.soldPrice' | transloco }}
                                }
                              }
                            </div>
                            <div class="ms-1 text-capitalize">
                              @if (authConfig?.IsArtist) {
                                {{ product.Product.ArtistRevenue | currency:'USD':'symbol':'1.2-2' }}
                              }
                              @if (authConfig?.IsGallery) {
                                @if (!product.IsProductSold) {
                                  {{ product.RetailPrice | currency:'USD':'symbol':'1.2-2' }}
                                }
                                @if (product.IsProductSold) {
                                  {{ product.ProductSoldPrice | currency:'USD':'symbol':'1.2-2' }}
                                }
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- Remove Product Dialog -->
  <p-dialog [(visible)]="DisplayRemoveProductDialog" [modal]="true" [closable]="true" [header]="'syncProducts.productInformation' | transloco"
    [style]="{ width: '600px' }">
    <div class="p-dialog-content">
      @if (selectedProduct) {
        <div class="mt-2">
          <!-- Warning Message -->
          <p class="fw-semibold mb-4">
            {{ 'syncProducts.removeWarningMessage' | transloco }}
          </p>
          <!-- Product Info Section -->
          <div class="d-flex gap-3 align-items-start mb-4">
            <!-- Product Image -->
            <img [src]="selectedProduct.Product.ProductImgUrl || 'assets/images/No-Image.png'" [alt]="'syncProducts.productImage' | transloco"
              class="rounded border" style="width: 90px; height: 90px; object-fit: cover;">
              <!-- Product Details -->
              <div class="d-flex flex-column">
                <h5 class="mb-1 fw-bold text-uppercase">{{ selectedProduct.Product.Name }}</h5>
                <!-- Artist Name -->
                @if (authConfig?.IsGallery) {
                  <div class="text-muted">
                    <strong class="text-uppercase">{{ 'syncProducts.artistColonLabel' | transloco }}</strong> {{ selectedProduct.ArtistName || 'N/A' }}
                  </div>
                }
                <!-- Date Section -->
                <div class="text-muted">
                  <strong class="text-uppercase">
                    @if (authConfig?.IsArtist) {
                      {{ 'syncProducts.createdDate' | transloco }}
                    }
                    @if (authConfig?.IsGallery) {
                      @if (!selectedProduct.IsProductSold) {
                        {{ 'syncProducts.dateAccepted' | transloco }}
                      }
                      @if (selectedProduct.IsProductSold) {
                        {{ 'syncProducts.dateSold' | transloco }}
                      }
                    }
                  </strong>
                  <span class="ms-1">
                    @if (authConfig?.IsArtist) {
                      {{ selectedProduct.Product.CreatedDate | date: 'dd/MM/yyyy' }}
                    }
                    @if (authConfig?.IsGallery) {
                      @if (!selectedProduct.IsProductSold) {
                        {{ selectedProduct.GalleryAcceptedDate | date: 'dd/MM/yyyy' }}
                      }
                      @if (selectedProduct.IsProductSold) {
                        {{ selectedProduct.ProductSoldDate | date: 'dd/MM/yyyy' }}
                      }
                    }
                  </span>
                </div>
                <!-- Price / Revenue Section -->
                <div class="text-muted">
                  <strong class="text-uppercase">
                    @if (authConfig?.IsArtist) {
                      {{ 'syncProducts.artistRevenue' | transloco }}
                    }
                    @if (authConfig?.IsGallery) {
                      @if (!selectedProduct.IsProductSold) {
                        {{ 'syncProducts.retailPrice' | transloco }}
                      }
                      @if (selectedProduct.IsProductSold) {
                        {{ 'syncProducts.soldPrice' | transloco }}
                      }
                    }
                  </strong>
                  <span class="ms-1">
                    @if (authConfig?.IsArtist) {
                      {{ selectedProduct.Product.ArtistRevenue | currency:'USD':'symbol':'1.2-2' }}
                    }
                    @if (authConfig?.IsGallery) {
                      @if (!selectedProduct.IsProductSold) {
                        {{ selectedProduct.RetailPrice | currency:'USD':'symbol':'1.2-2' }}
                      }
                      @if (selectedProduct.IsProductSold) {
                        {{ selectedProduct.ProductSoldPrice | currency:'USD':'symbol':'1.2-2' }}
                      }
                    }
                  </span>
                </div>
              </div>
            </div>
            <!-- Synced Stores Section -->
            @if (selectedProduct.ProductSyncedOnPlatformDTO && selectedProduct.ProductSyncedOnPlatformDTO.length > 0) {
              <div>
                <h6 class="mb-3 text-secondary fw-semibold">{{ 'syncProducts.syncedPlatforms' | transloco }}</h6>
                <div class="row g-3">
                  @for (store of selectedProduct.ProductSyncedOnPlatformDTO | filterByPlatform:activePlatform; track store) {
                    <div
                      [ngClass]="selectedProduct.ProductSyncedOnPlatformDTO.length === 1 ? 'col-12' : 'col-md-6'">
                      <div class="card shadow-sm border-0 rounded-3 h-100">
                        <div class="card-body d-flex flex-column justify-content-between">
                          <!-- Store Info -->
                          <div class="mb-2">
                            <h6 class="fw-bold mb-1">
                              @if (store.PlatformName === 'Shopify') {
                                {{ store.ShopifyStoreDetailDTO?.StoreName || store.ShopifyStoreDetailDTO?.StoreUrl || 'Shopify Store' }}
                              }
                              @if (store.PlatformName === 'WooCommerce') {
                                {{ store.WooCommerceStoreDetail?.StoreName || store.WooCommerceStoreDetail?.StoreUrl ||
                                'WooCommerce Store' }}
                              }
                              @if (store.PlatformName === 'SquareSpace') {
                                {{ store.SquareSpaceSitesDetailDto?.SiteInfo?.title || store.PlatformProductLink || 'Square Space Store' }}
                              }
                            </h6>
                            <p class="text-muted small mb-0">{{ 'syncProducts.platformStore' | transloco: { platform: store.PlatformName } }}</p>
                          </div>
                          <!-- Actions -->
                          <div
                            [ngClass]="selectedProduct.ProductSyncedOnPlatformDTO.length === 1 ? 'd-flex justify-content-between gap-2' : 'd-grid gap-2'">
                            @if (store.PlatformProductLink) {
                              <a [href]="store.PlatformProductLink" target="_blank" rel="noopener"
                                class="btn btn-sm btn-outline-primary w-100">
                                {{ 'syncProducts.viewOnStore' | transloco }}
                              </a>
                            }
                            <button
                              (click)="removeProduct(store.WooCommerceStoreDetail?.Id || store.ShopifyStoreDetailDTO?.Id || store.SquareSpaceSitesDetailDto?.Id)"
                              class="btn btn-sm btn-outline-danger w-100">
                              {{ 'syncProducts.removeFromThisStore' | transloco }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>

      <!-- Footer Buttons -->
      @if (!selectedProduct?.ProductSyncedOnPlatformDTO) {
        <div class="p-dialog-footer d-flex justify-content-end gap-2">
          <button pButton type="button" class="p-button-outlined p-button-secondary" [label]="'syncProducts.cancel' | transloco" (click)="closeDialog()">
          </button>
          <button (click)="removeProduct()" class="btn btn-sm btn-outline-danger">
            {{ 'syncProducts.removeFromThisStore' | transloco }}
          </button>
        </div>
      }
    </p-dialog>